import React, { useState, useMemo } from 'react'
import './order-cashier.scss'
import useBemClass from '@/utils/hooks/useBEMClass'
import { Expaned, Row } from '@/components/layout/layout'
import CashierOrderTable from './order-list/order-table/order-table'
import { DatePicker } from 'antd'
import SearchInput from '@/components/search-input/search-input'
import OrderCashierFilter, { IOrderCashierFilterData } from './order-filter/order-filter'
import dayjs from 'dayjs'
import moment, { Moment } from 'moment'
import { cashierOrderStore } from './store'
import { useDataRefresh } from '@/utils/hooks/useRefresh'
import OrderDataRefresh from './order-refresh/order-refresh'
import { layerManage, showLayer } from '@/utils/layer'

const OrderCashier = () => {
    const getCls = useBemClass('order-cashier')
    const [date, setDate] = useState<string[]>([
        dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD'),
    ])
    const [value, setValve] = useState<[Moment | null, Moment | null] | null>([moment().subtract(1, 'month'), moment()])
    const [keyWord, setKeyWord] = useState<string>('')

    const [filterConfig, setFilterConfig] = useState<IOrderCashierFilterData>({
        staffList: [],
        paymentList: [],
        orderStatus: 0,
    })

    const filterText = useMemo(() => {
        const txtArr: string[] = []

        if (filterConfig.paymentList.length) {
            txtArr.push(filterConfig.paymentList.map(p => p.name).join(';'))
        }
        if (filterConfig.staffList.length) {
            txtArr.push(filterConfig.staffList.map(p => p.user.realname).join(';'))
        }

        return txtArr.join('、')
    }, [filterConfig])

    const { refresh, lastRefreshTime, loading } = useDataRefresh({
        url: '/finance/runcashierorderstatistics',
        storageKey: 'cashier-order-data-refresh-time',
        onSuccess: () => {
            cashierOrderStore.setRefresh()
        },
    })

    return (
        <Expaned className={getCls()}>
            <div className={getCls('header')}>
                <OrderDataRefresh loading={loading} refreshTime={lastRefreshTime} onClick={refresh} />
                <div className="time-picker">
                    <DatePicker.RangePicker
                        value={value || [moment(date[0]), moment(date[1])]}
                        defaultValue={value || [moment(), moment().subtract(1, 'month')]}
                        allowClear={false}
                        dateRender={current => (
                            <div
                                className="ant-picker-cell-inner"
                                style={{
                                    borderRadius: '50%',
                                }}
                            >
                                {current.date()}
                            </div>
                        )}
                        disabledDate={current => {
                            if (!value) {
                                return false
                            }
                            const tooLate = value[0] && current.diff(value[0], 'month') >= 3
                            const tooEarly = value[1] && moment(value[1]).diff(current, 'month') >= 3
                            return !!tooEarly || !!tooLate
                        }}
                        onCalendarChange={val => {
                            setValve(val)
                        }}
                        onChange={(monent, dateString) => {
                            setDate(dateString[0] ? dateString : [])
                        }}
                        onOpenChange={open => {
                            if (open) {
                                setValve([null, null])
                            } else {
                                setValve(null)
                            }
                        }}
                        suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                    />
                </div>
                <div
                    style={{
                        width: '290px',
                        marginLeft: '10px',
                    }}
                >
                    <SearchInput
                        placeholder="请输入订单编号/会员信息"
                        onSearch={keyWord => {
                            setKeyWord(keyWord)
                        }}
                        onDelete={() => {}}
                    ></SearchInput>
                </div>
                <div
                    className={getCls('filter')}
                    data-cursor-pointer
                    onClick={() => {
                        showLayer(
                            <OrderCashierFilter
                                {...filterConfig}
                                onConfirm={data => {
                                    setFilterConfig(data)
                                }}
                                onCancel={() => {
                                    layerManage.pop()
                                }}
                            />,
                        )
                    }}
                    style={{
                        color: !filterText ? '#333' : '#14cc9b',
                    }}
                >
                    <i className="iconfont icon6shaixuan-20" data-font-size-20 />
                    <span data-margin-left-8>筛选</span>
                </div>
            </div>
            {keyWord && (
                <Row className={getCls('searchBox')}>
                    <div>
                        以下是
                        <span className="them-color" data-font-weight-600 data-padding-h-8>
                            {keyWord}
                        </span>
                        的搜索结果
                    </div>
                    <div
                        className={getCls('delete')}
                        onClick={() => {
                            setKeyWord('')
                        }}
                    >
                        <i data-cursor-pointer className="iconfont icon6guanbi-20" />
                    </div>
                </Row>
            )}
            <Expaned data-row className={getCls('content')}>
                <CashierOrderTable {...filterConfig} date={date} keyWord={keyWord} />
            </Expaned>
        </Expaned>
    )
}

export default OrderCashier
